import { buyPackageModalReducer, userReducer, customDataReducer } from '../../slices';

export const rootReducer = {
  buyPackage: buyPackageModalReducer,
  user: userReducer,
  custom: customDataReducer,
};
